// ==============================================
// ==================Import======================
// ==============================================

// ===============Component==================
import Carousel from 'react-bootstrap/Carousel';

// ==================Hooks===================
import { useSelector } from 'react-redux';

// ==================Style&IMG===================
import './style.scss';

function CarouselImages() {
// ==================Hooks===================

  const images = useSelector((state) => state.metadata.data.dataDoi.images);
  const responseImage = useSelector((state) => state.metadata.data.dataDoi.responseImage);
  const displayImage = useSelector((state) => state.metadata.data.dataDoi.displayImages);

  return (
    <>
      {(images.results !== undefined
      && images.results.length > 0
      && responseImage
      && displayImage
      && images.count > 0
      ) && (
      <div className="carousel_container">
        <div className="panel-heading">
          <h4 className="panel-title">Station Pictures</h4>
        </div>
        <Carousel slide={false} data-bs-theme="dark" interval={null} className="carousel">
          {images.results.map((el) => (
            <Carousel.Item key={el.id} className="carousel_item">
              <img className="d-block w-100 carousel_image" src={el.link} alt="slide of station" />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
      )}
      {((images.results === undefined
      || images.results.length === 0)
      && responseImage
      && displayImage
      && images.count === 0
      ) && (
        <div className="carousel_container">
          <div className="panel-heading">
            <h4 className="panel-title">Station Pictures</h4>
          </div>
          <p className="carousel_container--paragraph">No picture(s) for this station</p>
        </div>
      )}
      {((images.results === undefined || images.results.length === 0)
      && responseImage === false && displayImage) && (
        <div className="carousel_container">
          <div className="panel-heading">
            <h4 className="panel-title">Station Pictures</h4>
          </div>
          <p className="carousel_container--paragraph">API down</p>
        </div>
      )}
    </>
  );
}

export default CarouselImages;
